export default __webpack_public_path__ + "static/media/promocode_mobile_Cn.65535ac5.webp";